import { range } from 'lodash';

import * as OvationsApi from 'core/ovations-api';
import mockCertifiableAddress from './certifiableAddress';

export const mockNonCertifiedAddresses: OvationsApi.Types.NonCertifiedAddress[] = range(0, 7).map((i) => ({
    id: `_id__${i}`,
    type: OvationsApi.Enums.CertifiableAddressType.Customer,
    firstName: `testy-${i}`,
    lastName: 'tester',
    address: mockCertifiableAddress,
    phoneNumber: null,
    email: null,
    hasReplacement: false,
}));
